import { render, staticRenderFns } from "./GrowerContractsTab.vue?vue&type=template&id=36075f84&scoped=true&"
import script from "./GrowerContractsTab.vue?vue&type=script&lang=js&"
export * from "./GrowerContractsTab.vue?vue&type=script&lang=js&"
import style0 from "./GrowerContractsTab.vue?vue&type=style&index=0&id=36075f84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36075f84",
  null
  
)

export default component.exports